import { Layers, Radar } from "lucide-react";
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { CHART } from "../../../lib/constants";
import { IndustryBreakdown } from "../../industry/IndustryBreakdown";
import {
  CHART_HEIGHT, PIE_INNER, PIE_OUTER, TOOLTIP_STYLE, SOURCE_COLORS,
} from "../lib/chartTokens";

const SourceComposition = ({ sourceData, totalApps }) => (
  <div className="bg-card border border-border rounded-xl p-5">
    <h3 className="text-base font-semibold mb-4 flex items-center gap-2">
      <Layers className="w-4 h-4 text-primary" />
      Data Source Composition
    </h3>
    <div className="flex items-center gap-6">
      <div className="w-56 h-56 flex-shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={sourceData}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={85}
              dataKey="value"
              paddingAngle={2}
            >
              {sourceData.map((entry, i) => (
                <Cell key={entry.name} fill={entry.fill || SOURCE_COLORS[i % SOURCE_COLORS.length]} />
              ))}
            </Pie>
            <Tooltip {...TOOLTIP_STYLE} formatter={(v) => [`${v.toLocaleString()} apps`, "Count"]} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="flex-1 space-y-2">
        {sourceData.map((s, i) => {
          const pct = ((s.value / totalApps) * 100).toFixed(1);
          const color = s.fill || SOURCE_COLORS[i % SOURCE_COLORS.length];
          return (
            <div key={s.name} className="flex items-center gap-3" data-testid={`source-row-${i}`}>
              <div className="w-3 h-3 rounded-sm flex-shrink-0" style={{ backgroundColor: color }} />
              <span className="text-xs font-medium flex-1 truncate">{s.name}</span>
              <span className="text-xs tabular-nums font-semibold">{s.value.toLocaleString()}</span>
              <span className="text-xs text-muted-foreground tabular-nums w-12 text-right">{pct}%</span>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

const GovernanceFraming = ({ data }) => (
  <div className="bg-card border border-border rounded-xl p-5">
    <h3 className="text-base font-semibold mb-4 flex items-center gap-2">
      <Radar className="w-4 h-4 text-primary" />
      Governance Framing
    </h3>
    <div className={CHART_HEIGHT}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={PIE_INNER}
            outerRadius={PIE_OUTER}
            paddingAngle={2}
            dataKey="value"
          >
            {data.map((entry) => (
              <Cell key={`cell-${entry.name}`} fill={entry.fill} />
            ))}
          </Pie>
          <Tooltip {...TOOLTIP_STYLE} />
          <Legend wrapperStyle={CHART.legend} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export const DatasetComposition = ({ sourceData, governanceData, totalApps }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <SourceComposition sourceData={sourceData} totalApps={totalApps} />
    <IndustryBreakdown entityType="application" compact />
    <GovernanceFraming data={governanceData} />
  </div>
);

export default DatasetComposition;
